/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Force_End_TitleInputs */

const vi_trip_force_end_title = /** @type {(inputs: Trip_Force_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết thúc chuyến thủ công`)
};

/**

* @param {Trip_Force_End_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_force_end_title = /** @type {((inputs?: Trip_Force_End_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Force_End_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_force_end_title(inputs)
});